export default "__VITE_ASSET__CRjh$G3I__"